var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "m--0 cursor-pointer" },
    [
      _c(
        "b-col",
        {
          staticStyle: {
            "padding-right": "0px!important",
            "padding-left": "0px!important"
          },
          attrs: { cols: "1" }
        },
        [
          _c("img", {
            staticClass: "m__t--5",
            attrs: { src: require("@/assets/icon/form-2.png"), height: "40" }
          })
        ]
      ),
      _vm._v(" "),
      _c("b-col", { staticClass: "m__t--5", attrs: { cols: "11" } }, [
        _c("h4", { staticClass: "m__b--0" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                JSON.parse(_vm.element.info).title
                  ? JSON.parse(_vm.element.info).title
                  : ""
              ) +
              "\n    "
          )
        ]),
        _vm._v(
          "\n    " +
            _vm._s(
              JSON.parse(_vm.element.info).name
                ? JSON.parse(_vm.element.info).name
                : ""
            ) +
            "\n  "
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e1848a58", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e1848a58","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/widget/widget-card/jCreateRecordWidget.vue
// module id = null
// module chunks = 